<template>
  <div class="section-professional-cover-photos">
    <div class="">
      <div class="embed-responsive embed-responsive-16by9" v-if="isVideo(experience.experience_photos[0].image_sm)">
        <iframe class="embed-responsive-item" :src="experience.experience_photos[0].image_sm" allowfullscreen></iframe>
      </div>
      <img v-lazy="experience.experience_photos[0].image_xl"
           :alt="experience.experience_photos[0].title"
           class="img-fluid rounded-all"
           @click="$parent.openGallery(0)"
           v-else>
    </div>
    <div class="section-view-photos">
      <div class="bg-white border border-dark rounded py-2 px-3 text-small m-2" @click="$parent.openGallery(0)">
        <i class="fas fa-th"></i> {{ $t('message.professional.menu.view_photos') }}
      </div>
    </div>
  </div>
</template>

<script>
  import fileHelpers from '../../../helpers/fileHelpers'

  export default {
    props: {
      experience: Object
    },
    methods: {
      isVideo (url) {
        return fileHelpers.isVideo(url)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/experience/components/PhotosMobile.vue